import { useState, useEffect } from "react";
import { getBookingUiFromStorage } from "../lib/bookingUi";

/**
 * Foglalóoldal dizájnja: külön a menedzsmenttől, de örökli, ha nincs saját mentés.
 */
export function useBookingUiVariant() {
  const [ui, setUi] = useState(() => getBookingUiFromStorage());

  useEffect(() => {
    const bump = () => setUi(getBookingUiFromStorage());
    window.addEventListener("xclean:booking-ui-changed", bump);
    window.addEventListener("xclean:ui-changed", bump);
    return () => {
      window.removeEventListener("xclean:booking-ui-changed", bump);
      window.removeEventListener("xclean:ui-changed", bump);
    };
  }, []);

  return ui === "studio" ? "studio" : "classic";
}
